export const FLOW_COMPLETED = 'FLOW_COMPLETED';
export const FLOW_CANCELED = 'FLOW_CANCELED';